import React from 'react';

const RELOAD_KEY = 'm2b_lazy_chunk_reload';

/**
 * React.lazy wrapper that retries failed dynamic imports, then does one
 * hard reload per tab session (covers stale chunks after deploy).
 * First-navigation blank screens often come from a failed lazy chunk.
 */
export function lazyWithRetry(factory) {
  return React.lazy(async () => {
    try {
      const mod = await factory();
      try {
        sessionStorage.removeItem(RELOAD_KEY);
      } catch {
        /* ignore */
      }
      return mod;
    } catch (firstErr) {
      try {
        await new Promise((r) => setTimeout(r, 400));
        const mod = await factory();
        try {
          sessionStorage.removeItem(RELOAD_KEY);
        } catch {
          /* ignore */
        }
        return mod;
      } catch (retryErr) {
        let alreadyReloaded = false;
        try {
          alreadyReloaded = sessionStorage.getItem(RELOAD_KEY) === '1';
        } catch {
          /* ignore */
        }
        if (!alreadyReloaded && typeof window !== 'undefined') {
          try {
            sessionStorage.setItem(RELOAD_KEY, '1');
          } catch {
            /* ignore */
          }
          window.location.reload();
          // Suspend until the page unloads so React does not paint a blank error.
          return new Promise(() => {});
        }
        throw retryErr || firstErr;
      }
    }
  });
}
